export default "__VITE_ASSET__C1NS13Hq__"